import { Injectable } from '@angular/core';

import { Observable, of, catchError, map, tap } from 'rxjs';

import { Instrument, InstrumentGroup } from '@personal-area/global/accounts/models';

import { InstrumentsApiService } from './instruments.api.service';

@Injectable()
export class InstrumentsService {

  private _cache: {
    groups: InstrumentGroup[];
    instruments: { [type: string]: Instrument[] };
  };

  constructor(
    private _instrumentsApiService: InstrumentsApiService
  ) {
    this._cache = { groups: [], instruments: {} };
  }

  public getGroups(): Observable<InstrumentGroup[]> {
    if (this._cache.groups.length) {
      return of(this._cache.groups);
    }

    return this._instrumentsApiService.getGroups()
      .pipe(
        map(groups => groups.map(group => {
          group.title = group.title.replace(/ /g, '_');
          return group;
        })),
        tap(data => this._cache.groups = data),
        catchError(err => of(null))
      );
  }

  public getInstrumentsByAccountType(type: string): Observable<Instrument[]> {
    if (this._cache.instruments[type]) {
      return of(this._cache.instruments[type]);
    }

    return this._instrumentsApiService.getInstrumentsByAccountType(type)
      .pipe(
        tap(data => this._cache.instruments[type] = data),
        catchError(err => of(null))
      );
  }

  public refresh() {
    this._cache = { groups: [], instruments: {} };
  }
}
